<style lang="scss" scoped>
@use '~@/styles/main';
@use '~@/styles/base/variables';

.chart-header {
  display: flex;
  display: flex;
  align-items: center;
  background-color: var(--color-chart);
  border-bottom: 1px solid var(--color-chart-border);
}

.delete-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 61px;
  min-width: 52px;
  height: 100%;
  color: var(--color-text-dark);
  cursor: pointer;

  &:hover {
    color: var(--color-text-light);
    background-color: var(--color-card);
  }
}

.panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 5px 20px;
  overflow: auto;
  gap: 5px;

  @media screen and (max-width: variables.$small) {
    padding: 0;
  }

  &::before,
  &::after {
    content: '';
  }
}

.indicator {
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 5px;
  white-space: nowrap;

  .label {
    font-size: 12px;
    color: var(--color-text-dark);
    text-align: right;
    cursor: unset;
  }

  .value {
    font-size: 14px;
    text-align: left;

    &_price {
      min-width: 12ch;
    }

    @media screen and (max-width: variables.$small) {
      min-width: unset;
    }
  }
}
</style>

<template>
  <header class="chart-header">
    <button
      @click="deleteChart()"
      class="delete-btn chart-delete-btn"
    >
      <Icon
        size="18"
        :title="$text.tr('Закрыть окно')"
        type="md-close"
      />
    </button>
    <div class="panel">
      <div class="indicator">
        <label class="label">
          {{ $text.tr('ЦЕНА') }}
        </label>
        <span class="value value_price">
          {{ lastPrice ? lastPrice : currentItem.price }}
        </span>
      </div>
      <div class="indicator">
        <label class="label">
          {{ $text.tr('24Ч ИЗМЕНЕНИЕ') }}
        </label>
        <span
          class="value"
          :class="[currentItem.Change24h >= 0 ? 'ggreen' : 'gred']"
        >
          {{ `${currentItem.Change24h} %` }}
        </span>
      </div>
      <div class="indicator">
        <label class="label">
          {{ $text.tr('24Ч ОБЪЕМ') }}
        </label>
        <span class="value">
          {{ `${currentItem.Volume24h} ${currentItem.quoteAsset}` }}
        </span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: { chart: Object, symbols: Array },
  data () {
    return {
      id: this.chart.id,
      symbol: this.chart.symbol
    }
  },
  computed: {
    lastPrice () {
      return this.chart.lastPrice
    },
    currentItem () {
      return (
        (this.symbols &&
          this.symbols.find(
            item => `${item.baseAsset}/${item.quoteAsset}` === this.symbol
          )) || {
          price: '',
          Change24h: '',
          Volume24h: '',
          quoteAsset: ''
        }
      )
    }
  },
  methods: {
    deleteChart () {
      localStorage.removeItem(this.intervalId)
      this.$emit('delete')
    }
  }
}
</script>
